import * as React from "react";
import { useTranslation } from "react-i18next";

import { ContactLanguages } from "../../../../../../company/settings/translations";
import Button from "../../../Button/Button";
import LanguageSelector from "../../../LanguageSelector/LanguageSelector";
import { getLink } from "../../../shared/utils/getLink";
import { getSlugWithLang } from "../../../shared/utils/getSlugWithLang";
import Hamburger, { IBurger } from "../hamburger/Hamburger";

type PropsToolbar = {
  burger: IBurger;
};
const Toolbar: React.FC<PropsToolbar> = (props: PropsToolbar) => {
  const { t, i18n } = useTranslation("global");
  return (
    <div className={`m-toolbar`}>
      <LanguageSelector />
      <Button actionLink={getSlugWithLang(ContactLanguages[i18n.language].slug, i18n.language)}>
        {ContactLanguages[i18n.language].name}
      </Button>
      <Hamburger sidebar={props.burger.sidebar} toggle={props.burger.toggle} />
    </div>
  );
};

export default Toolbar;
